"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _core = require("@material-ui/core");

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AppStore = _interopRequireDefault(require("../../Store/AppStore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * File: CardholderInfo.js
 * Project: tsys-online-payments
 *
 * Created by Jed Dumire on 09/09/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description:
 */
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      maxWidth: 550,
      padding: theme.spacing(2)
    },
    fullWidth: {
      width: "100%"
    },
    address: {
      width: "66%"
    },
    zip: {
      width: "33%"
    },
    defaultCard: {
      marginRight: theme.spacing(-1)
    },
    uppercase: {
      textTransform: "capitalize"
    }
  };
});

var CardholderInfo = function CardholderInfo(_ref) {
  var cardStore = _ref.cardStore;
  var classes = useStyles();
  var history = (0, _reactRouterDom.useHistory)();
  var disableNext = !cardStore.accountName || !cardStore.addressLine1 || !cardStore.zip;

  if (!_AppStore.default.selectedAccount || !_AppStore.default.paymentAmount || !_AppStore.default.enteredCardInfo.token) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: "/accountSelect"
    });
  }

  var goBack = function goBack() {
    _AppStore.default.reloadTSEPScripts();

    history.goBack();
  };

  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "column",
    className: classes.root,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    inputProps: {
      className: classes.uppercase
    },
    variant: "outlined",
    label: "Name on Card",
    fullWidth: true,
    required: true,
    value: cardStore.accountName,
    onChange: function onChange(e) {
      return cardStore.setAccountName(e.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.address
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    inputProps: {
      className: classes.uppercase,
      maxLength: "60"
    },
    variant: "outlined",
    label: "Billing Address (Street Address)",
    fullWidth: true,
    value: cardStore.addressLine1,
    onChange: function onChange(e) {
      return cardStore.setAddress(e.target.value);
    },
    required: true
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.zip
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    inputProps: {
      style: {
        textTransform: "uppercase"
      },
      minLength: "2",
      maxLength: "15"
    },
    variant: "outlined",
    label: "Zip Code",
    fullWidth: true,
    value: cardStore.zip,
    onChange: function onChange(e) {
      return cardStore.setZip(e.target.value);
    },
    required: true
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.fullWidth,
    variant: "outlined",
    color: "primary",
    startIcon: /*#__PURE__*/_react.default.createElement(_ArrowBack.default, null),
    onClick: goBack
  }, "Go Back")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.fullWidth,
    variant: "contained",
    color: "primary",
    component: _reactRouterDom.Link,
    to: "/summary",
    disabled: disableNext
  }, "Next")));
};

CardholderInfo.propTypes = {
  cardStore: _propTypes.default.shape({
    accountName: _propTypes.default.string.isRequired,
    setAccountName: _propTypes.default.func.isRequired,
    addressLine1: _propTypes.default.string,
    setAddress: _propTypes.default.func.isRequired,
    zip: _propTypes.default.string,
    setZip: _propTypes.default.func.isRequired
  }).isRequired
};

var _default = (0, _mobxReact.observer)(CardholderInfo);

exports.default = _default;